import { render, staticRenderFns } from "./QuestionnaireSection.vue?vue&type=template&id=1271f989&scoped=true&"
import script from "./QuestionnaireSection.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireSection.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireSection.vue?vue&type=style&index=0&lang=css&"
import style1 from "./QuestionnaireSection.vue?vue&type=style&index=1&id=1271f989&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1271f989",
  null
  
)

export default component.exports